module.exports = __webpack_public_path__ + "static/info-3b0168b5958d2f958c80d58570039f6a.jpg";